<template>
    <div>
        <div v-if="authUserPermission['stock-calc-slow-by-manual']">
            <div class="container-fluid mt-4">
                <div class="row no-gutters justify-content-center mb-4">
                    <div class="col-md-5">
                        <button class="btn-sm btn m-0 w-100 rounded-0 p-2"
                            :class="params.flag == 1 ? 'btn-darks' : 'btn-light'" @click="goToFrontPage(1)">
                            Draft</button>
                    </div>
                    <div class="col-md-5">
                        <button class="btn-sm w-100 btn-rounded-non btn p-2"
                            :class="params.flag == 2 ? 'btn-darks' : 'btn-light'" @click="goToFrontPage(2)">
                            Submission</button>
                    </div>
                </div>
                <div class="card mb-4 rounded-0" style="font-size: 12px!important;">
                    <div class="card-body">
                        <div class="stepper d-flex justify-content-center mb-6">
                            <span v-for="(step, index) in steps" :key="index"
                                :class="['step', { active: index === currentStep }]" @click="currentStep = index"
                                class="cursor-pointer">
                                {{ step }}
                                <span v-if="index < steps.length - 1" class="fas fa-chevron-right fa-lg mx-3"></span>
                            </span>
                        </div>

                        <stock-calc-table-result :items="data?.items" v-if="currentStep == 0" />

                        <stock-calc-table1 @selected-abc-indicator="onSelectedAbcIndicator" :items="data?.items"
                            v-if="currentStep == 1" />
                        <stock-calc-table2 @selected-rop="onSelectedRop" :items="data?.items" v-if="currentStep == 2" />
                        <stock-calc-table3 @selected-rop="onSelectedEoq" :items="data?.items" v-if="currentStep == 3" />
                        <stock-calc-sumary-table @selected-rop="onSelectedEoq" @is-delete-item="onDeleteItem" :data="data" :items="data?.items"
                            v-if="currentStep == 4" />

                        <div class="d-flex justify-content-center mb-4">
                            <div v-if="currentStep == 0">
                                <button class="btn btn-primary px-5" @click="currentStep = 1">Next</button>
                            </div>
                            <div v-else>
                                <button class="btn bg-grey px-5" @click="currentStep--">Back
                                </button>

                                <base-button v-if="!(currentStep === (steps.length - 1))" class="btn btn-yellow px-5"
                                    :loading="saveLoading" @click="save" :disabled="saveLoading">Save</base-button>

                                <base-button v-if="currentStep === (steps.length - 1)" class="btn btn-yellow px-5"
                                    :loading="loadingSubmit" @click="() => visibleModalSubmit = true"
                                    :disabled="!enableSubmit || loadingSubmit">Submit</base-button>

                                <button class="btn btn-primary px-5" v-if="!(currentStep === (steps.length - 1))"
                                    @click="currentStep++">Skip</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- modal submit as draft -->
            <el-dialog title="Submit Pengajuan" :visible.sync="visibleModalSubmit" width="30%"
                :before-close="() => visibleModalSubmit = false" :close-on-click-modal="false">
                <div class="mb-4">
                        <label class="form-control-label">Approver <span class="text-danger">*</span></label>
                        <br>
                        <el-select class="w-100" v-model="approver" :placeholder="tt('choose_receiver')" filterable remote reserve-keyword clearable>
                            <el-option v-for="a in approvers" :key="a.namecode" :label="a.username +' - '+ a.name" :value="a.namecode"></el-option>
                        </el-select>
                    </div>
                    <div class="d-flex justify-content-end">
                        <base-button type="light" @click="() => visibleModalSubmit = false" :loading="loadingSubmit">
                            Batal
                        </base-button>
                        <base-button type="primary" @click="submit" :disabled="loadingSubmit" :loading="loadingSubmit">
                            Submit
                        </base-button>
                    </div>
            </el-dialog>
        </div>
        <noaccess v-else />
    </div>
</template>
<script>
import { mapState } from 'vuex'
import Api from '@/helpers/api';
import Empty from '../../components/Empty.vue';
import stockCalcService from '@/services/material/stockCalculation.service';
import moment from 'moment';
import 'moment/locale/id'
import StockCalcSumaryTable from '@/views/StockCalculation/Components/StockCalcSumaryTable.vue';
import StockCalcTableResult from '@/views/StockCalculation/Components/StockCalcResultTable.vue';
import StockCalcTable1 from '@/views/StockCalculation/Components/StockCalcTable1.vue';
import StockCalcTable2 from '@/views/StockCalculation/Components/StockCalcTable2.vue';
import StockCalcTable3 from '@/views/StockCalculation/Components/StockCalcTable3.vue';
import Swal from "sweetalert2";

export default {
    name: 'StockCalcSubmissionsSubmit',
    components: {
        Empty,
        StockCalcTableResult,
        StockCalcTable1,
        StockCalcTable2,
        StockCalcTable3,
        StockCalcSumaryTable
    },
    data() {
        return {
            id: null,
            data: null,
            loadingPage: false,
            params: {
                flag: 1
            },
            steps: ['Result', 'ABC Indicator', 'Reorder Point', 'Maximum', 'Summary'],
            currentStep: 0,
            slug: null,
            saveLoading: false,
            enableSubmit: false,
            visibleModalSubmit: false,
            loadingSubmit: false,
            approvers: [],
            approver: null
        }
    },
    methods: {
        goToFrontPage(value) {
            this.$router.push(`/stock-calculation/stock-calc-submissions?flag=${value}`);
        },
        save() {
            Swal.fire({
                title: "Confirmation",
                html: "Apakah Anda yakin?",
                icon: "info",
                showCancelButton: true,
                confirmButtonColor: "#5e72e4",
                cancelButtonColor: "#f5365c",
                confirmButtonText: "Yes",
                heightAuto: false,
            }).then(async (result) => {
                if (result.isConfirmed) {
                    this.saveLoading = true
                    const payload_data = { items: this.getPayloadForSave() }
                    Api(this, stockCalcService.escalationSave(payload_data, this.id, this.slug))
                        .onSuccess((response) => {
                            Swal.fire({
                                title: 'Sukses!',
                                text: 'Data berhasil disimpan.',
                                icon: 'success',
                                confirmButtonText: 'OK'
                            }).then(() => {
                                this.getDetail(this.id)
                            })
                        })
                        .onError((error) => {
                            const errorMessage = error?.response?.data?.message ?? 'Gagal, Terjadi kesalahan.'
                            this.$notify({
                                message: errorMessage,
                                type: 'danger',
                                verticalAlign: "bottom",
                                horizontalAlign: "left"
                            });
                        })
                        .onFinish(() => {
                            this.saveLoading = false
                        })
                        .call()
                }
            })
        },
        getPayloadForSave() {
            if (this.currentStep == 1) {
                this.slug = 'abc-indicator'
                return this.data.items.map(item => ({
                    id: item.id,
                    abc_indicator_result: item?.abc_indicator_result,
                    description_abc_indicator: item?.description_abc_indicator
                }))
            } else if (this.currentStep == 2) {
                this.slug = 'reorder-point'
                return this.data.items.map(item => ({
                    id: item.id,
                    rop_result: item?.rop_result,
                    description_rop: item?.description_rop
                }))
            } else if (this.currentStep == 3) {
                this.slug = 'maximum'
                return this.data.items.map(item => ({
                    id: item.id,
                    eoq_result: item?.eoq_result,
                    description_eoq: item?.description_eoq
                }))
            }
        },
        getAbcIndicatorSelected(item) {
            if (item?.abc_indicator_result == item.abc_indicator_calculate) {
                return {
                    value: 'yes',
                    bg: 'bg-light-green'
                }
            } else if (item?.abc_indicator_result == item.abc_indicator) {
                return {
                    value: 'no',
                    bg: 'bg-light-red'
                }
            } else if (item?.abc_indicator_result) {
                return {
                    value: 'other',
                    bg: 'bg-light-blue'
                }
            } else {
                return {
                    value: '',
                    bg: ''
                }
            }
        },
        getRopSelected(item) {
            if (item?.rop_result == item.rop_calculate) {
                return {
                    value: 'yes',
                    bg: 'bg-light-green'
                }
            } else if (item?.rop_result == item.rop) {
                return {
                    value: 'no',
                    bg: 'bg-light-red'
                }
            } else if (item?.rop_result) {
                return {
                    value: 'other',
                    bg: 'bg-light-blue'
                }
            } else {
                return {
                    value: '',
                    bg: ''
                }
            }
        },
        getEoqSelected(item) {
            if (item?.eoq_result == item.eoq_calculate) {
                return {
                    value: 'yes',
                    bg: 'bg-light-green'
                }
            } else if (item?.eoq_result == item.eoq) {
                return {
                    value: 'no',
                    bg: 'bg-light-red'
                }
            } else if (item?.eoq_result) {
                return {
                    value: 'other',
                    bg: 'bg-light-blue'
                }
            } else {
                return {
                    value: '',
                    bg: ''
                }
            }
        },
        getItems(item) {
            const abc_indicator_seleted = this.getAbcIndicatorSelected(item)
            const rop_seleted = this.getRopSelected(item)
            const eoq_seleted = this.getEoqSelected(item)
            return {
                selected_abc_indicator: abc_indicator_seleted?.value,
                selected_abc_indicator_bg: abc_indicator_seleted?.bg,
                selected_rop: rop_seleted?.value,
                selected_rop_bg: rop_seleted?.bg,
                selected_eoq: eoq_seleted?.value,
                selected_eoq_bg: eoq_seleted?.bg,
                ...item
            }
        },
        getDetail(id) {
            this.loadingPage = true

            Api(this, stockCalcService.getSubmissionDetail(id))
                .onSuccess((response) => {
                    const data = response?.data?.data
                    const items = data?.items.map((item) => this.getItems(item))
                    data.items = items
                    this.data = data
                    this.approver = data?.assigned_to
                    this.currentStep = data?.step_number == 0 ? 0 : data?.step_number + 1
                })
                .onError((error) => {
                    const errorMessage = error?.response?.data?.message ?? 'Gagal, Terjadi kesalahan.'
                    this.$notify({
                        message: errorMessage,
                        type: 'danger',
                        verticalAlign: "bottom",
                        horizontalAlign: "left"
                    });
                })
                .onFinish(() => {
                    this.loadingPage = false
                })
                .call()
        },
        formatTanggal(value) {
            if (!value) return '-';
            return moment(value).format('D MMMM YYYY');
        },
        onSelectedAbcIndicator(items_updated) {
            const data = this.data
            data.items = items_updated
            this.data = data
        },
        onSelectedRop(items_updated) {
            const data = this.data
            data.items = items_updated
            this.data = data
        },
        onSelectedEoq(items_updated) {
            const data = this.data
            data.items = items_updated
            this.data = data
        },
        onDeleteItem(value) {
            console.log(value)
            if (value) {
                this.loadingSubmit = true
            } else {
                this.loadingSubmit = false
                this.getDetail(this.id)
            }
        },
        submit() {
             Swal.fire({
                title: "Confirmation",
                html: "Apakah Anda yakin?",
                icon: "info",
                showCancelButton: true,
                confirmButtonColor: "#5e72e4",
                cancelButtonColor: "#f5365c",
                confirmButtonText: "Yes",
                heightAuto: false,
            }).then(async (result) => {
                if (result.isConfirmed) {
                    this.loadingSubmit = true
                    const payload_data = {assigned_to: this.approver}
                    const uri = this.data?.status == 1 ? 'submit' : 'resubmit'
                    Api(this, stockCalcService.submit(this.id, uri, payload_data))
                        .onSuccess((response) => {
                            Swal.fire({
                                title: 'Sukses!',
                                text: 'Data berhasil disubmit.',
                                icon: 'success',
                                confirmButtonText: 'OK'
                            }).then(() => {
								this.$router.push({path:'/stock-calculation/stock-calc-submissions', query: null})
                            })
                        })
                        .onError((error) => {
                            const errorMessage = error?.response?.data?.message ?? 'Gagal, Terjadi kesalahan.'
                            this.$notify({
                                message: errorMessage,
                                type: 'danger',
                                verticalAlign: "bottom",
                                horizontalAlign: "left"
                            });
                        })
                        .onFinish(() => {
                            this.loadingSubmit = false
                            this.visibleModalSubmit = false
                        })
                        .call()
                }
            })
        }
    },
    created() {
        moment.locale('id')
        this.id = this.$route.params.id
        this.getDetail(this.id)
    },
    computed: {
        ...mapState({
            authUserPermission: state => state.auth.userPermission
        })
    },
    watch: {
        'data.items': function () {
            let enableSubmit = true

            this.data.items.forEach(item => {
                if (!item.abc_indicator_result) enableSubmit = false
                if (!item.rop_result) enableSubmit = false
                if (!item.eoq_result) enableSubmit = false
            });

            this.enableSubmit = enableSubmit
        },
        'enableSubmit': function () {
            if (this.enableSubmit) {
                Api(this, stockCalcService.getApprovers())
                    .onSuccess((response) => {
                        this.approvers = response?.data?.data
                    })
                    .onError((error) => {
                        this.approver = []
                    })
                    .onFinish(() => {})
                    .call()
            }
        }
    }
};
</script>


<style scoped>
.card {
    font-family: sans-serif;
    color: #000;
}

.el-tooltip__popper {
    max-width: 320px !important;
    word-break: break-word;
}

.btn-darks {
    background-color: #172b4d !important;
    color: white;
}

.badge {
    border-radius: 6px;
    font-size: 0.75rem;
}

.bg-yellow {
    background-color: yellow !important;
    color: silver !important;
}

.stepper {
    font-family: sans-serif;
    font-size: 14px;
    gap: 0.5rem;
}

.step {
    color: #000;
}

.step.active {
    font-weight: bold;
}
</style>